// extracted by mini-css-extract-plugin
export default {"link":"AdminNavItem_link__MQxwS","linkActive":"AdminNavItem_linkActive__sDG5k","dot":"AdminNavItem_dot__0jSXO","label":"AdminNavItem_label__c-DX0"};